import AlternateEmail from '@mui/icons-material/AlternateEmail';
import { s } from '../../format/schema';
import { defineFieldType, formatMessageSetting } from '../card';
import { FormatMessageSettingsPanel } from '../shared/FormatMessageSettingsPanel';
import { EmailInput } from './FillInput';

export const email = defineFieldType({
  type: 'email',
  name: 'Email',
  valueKind: 'text',
  settings: s.strictObject(formatMessageSetting),
  defaults: {},
  value: s.string(),
  emptyValue: '',
  hasDefaultValue: true,
  validations: ['required', 'unique'],
  operators: ['isFilled', 'isEmpty', 'equals', 'notEquals', 'contains', 'notContains', 'startsWith', 'endsWith'],
  palette: [{ name: 'Email', tooltip: 'Email address', group: 'Text', icon: AlternateEmail }],
  isEmpty: value => value.trim() === '',
  comparable: value => value.trim().toLowerCase(),
  builtInCheck: () => 'emailFormat',
  stored: value => value.trim(),
  FillInput: EmailInput,
  settingsPanel: { at: 'settings', Panel: FormatMessageSettingsPanel },
});
